import styled from 'styled-components'
import {
  OPPORTUNITY_DETAIL_COVER_ASPECT_HEIGHT,
  OPPORTUNITY_DETAIL_COVER_ASPECT_WIDTH,
} from '../../../opportunityCoverDimensions'

export const ELEVATION2_SHADOW = '0px var(--Elevation2OffsetY, 2px) var(--Elevation2Radius, 8px) 0px #00000029'

export const AboutRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;

  @media (max-width: 768px) {
    gap: 12px;
  }
`

export const CoverBannerWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  flex: 1 1 auto;
  align-self: stretch;
  aspect-ratio: ${OPPORTUNITY_DETAIL_COVER_ASPECT_WIDTH} / ${OPPORTUNITY_DETAIL_COVER_ASPECT_HEIGHT};
  border-radius: 10px;
  overflow: hidden;
  box-shadow: ${ELEVATION2_SHADOW};
  box-sizing: border-box;

  @media (max-width: 768px) {
    border-radius: 8px;
  }

  @media (max-width: 480px) {
    border-radius: 6px;
  }
`

export const CoverBanner = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  min-width: 100%;
  min-height: 100%;
  display: block;
  object-fit: cover;
  object-position: center;
`

export const MetaBar = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  background: #eef4fe;
  padding: 20px 24px;
  border-radius: 8px;
  box-shadow: ${ELEVATION2_SHADOW};

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 16px;
  }
`

export const MetaItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`

export const MetaLabel = styled.span`
  font-family: 'Caixa Std', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #0066b3;
  line-height: 1.4;
`

export const MetaValue = styled.span`
  font-family: 'Caixa Std', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #374151;
  line-height: 1.5;
  word-break: break-word;
`

export const DescriptionCard = styled.div`
  background: #ffffff;
  padding: 24px;
  border-radius: 8px;
  box-shadow: ${ELEVATION2_SHADOW};
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  overflow: hidden;
`

export const DescriptionHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 26px;
  margin-bottom: 20px;
`

export const DescriptionTitle = styled.h2`
  font-family: 'Caixa Std', sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #1f2937;
  width: 100%;
  max-width: 100%;
  min-height: 26px;
  line-height: 26px;
  margin: 0;
`

export const DescriptionDivider = styled.hr`
  border: none;
  border-top: 1px solid #e5e7eb;
  width: 100%;
  max-width: 100%;
  margin: 0;
`

export const DescriptionBody = styled.div`
  font-family: 'Caixa Std', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #374151;
  line-height: 1.65;
  margin-bottom: 24px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-wrap: anywhere;
  word-break: break-word;

  p {
    margin: 0 0 12px;
  }

  p:last-child {
    margin-bottom: 0;
  }

  ul,
  ol {
    margin: 0 0 12px;
    padding-left: 20px;
  }

  img,
  video,
  iframe {
    max-width: 100%;
    height: auto;
  }

  pre {
    white-space: pre-wrap;
    overflow-wrap: anywhere;
    word-break: break-word;
    max-width: 100%;
  }

  table {
    display: block;
    max-width: 100%;
    overflow-x: auto;
  }
`

export const DetailBlock = styled.div`
  margin-bottom: 20px;
  width: 100%;
  max-width: 100%;
  min-width: 0;

  &:last-child {
    margin-bottom: 0;
  }
`

export const DetailLabel = styled.p`
  font-family: 'Caixa Std', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 8px;
`

export const DetailValue = styled.p`
  font-family: 'Caixa Std', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #374151;
  margin: 0;
  line-height: 1.55;
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;
`

export const DetailLink = styled.a`
  font-family: 'Caixa Std', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #0066b3;
  text-decoration: underline;
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;
  display: inline-block;
  line-height: 1.55;
  cursor: pointer;

  &:hover {
    color: #004578;
  }
`

export const SupportFilesList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
`

const supportFileChipBase = `
  display: inline-flex;
  align-items: center;
  gap: 8px;
  width: 313px;
  max-width: 100%;
  height: 32px;
  padding: 0 8px;
  background: #c5e6ff;
  border: none;
  border-radius: 4px;
  color: #0066b3;
  font-family: 'Caixa Std', sans-serif;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
  box-sizing: border-box;

  svg {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
  }

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 1;
  }
`

export const SupportFileChip = styled.a`
  ${supportFileChipBase}
  text-decoration: none;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #b3dcff;
    color: #0066b3;
  }
`

export const SupportFileChipStatic = styled.div`
  ${supportFileChipBase}
`
